<template>
  <div id='no-order-selected'>
    <h2>No Order Selected</h2>
    <p>Select an order or <b-button @click='new_order' variant='link' :disabled='busy'>create a new order</b-button>.</p>
  </div>
</template>


<script>
import { mapActions } from 'vuex';

export default {
  name: 'NoOrderSelected',
  data () {
    return {
      busy: false,
    }
  },
  methods: {

    ...mapActions( 'orders', {
      create_new_order: 'create_new'
    }),

    new_order () {
      if ( !this.busy ) {
        this.busy = true;
        const busy_id = this.$jjToast({
          type: 'busy',
          title: 'Loading',
          content: 'Creating new order',
        });
        this.create_new_order()
          .catch( () => {
            this.$jjToast({
              type: 'error',
              title: 'Error',
              content: 'Failed to create new order',
            });
          })
          .finally( () => {
            this.busy = false;
            this.$bvToast.hide( busy_id );
          });
      }
    }

  }
}
</script>


<style scoped lang='scss'>
#no-order-selected {
  padding: 1.5rem;
  text-align: center;
}
button {
  color: var( --secondary );
  display: inline;
  vertical-align: baseline;
  padding: 0;
  text-decoration: underline;
}
p {
  margin: 1rem 0 0;
}
</style>